<button [class]="'button ' + fromSize(size) + ' ' + fromVisibility(visibility) + ' ' + fromRole(role)" type="button"
        [class._disabled]="disabled" (click)="doAction($event)"
        [class._pulse]="pulse">
    <div (click)="doAction($event)">
        <ng-content></ng-content>
    </div>
</button>
